<template>
  <div class="customer-list">
    <Toolbar :handle-add="addHandler" v-if="userHasAccess('customer_edit')"/>

    <v-container grid-list-xl fluid>
      <v-layout row wrap>
        <v-flex sm12>
          <h1><v-icon large>mdi-account-cash</v-icon>{{$t('qualitycheck.customer.customers')}}</h1>
        </v-flex>
        <v-flex lg12>
          <DataFilter :handle-filter="onSendFilter" :handle-reset="resetFilter">
            <CustomerFilterForm
              ref="filterForm"
              :values="filters"
              slot="filter"
            />
          </DataFilter>

          <br />

          <v-data-table
            v-model="selected"
            :headers="headers"
            :items="items"
  :items-per-page.sync="options.itemsPerPage"
:footer-props="footer"
            :loading="isLoading"
            :loading-text="$t('global.loading')"
            :options.sync="options"
            :server-items-length="totalItems"
            class="elevation-1"
            item-key="@id"
            @update:options="onUpdateOptions"
@click:row="showHandler"
@contextmenu:row="showHandlerExt"
          >
          <template slot="item.tags" slot-scope="{ item }">
            <div id="tags">
            <v-chip v-for="tag in item['tags']" :key="tag.id"
              class="ma-1 font-weight-bold"

              color="secondary"
            >
              {{ tag.name }}
            </v-chip>
          </div>
          </template>
            <ActionCell
              slot="item.action"
              slot-scope="props"
              :handle-show="() => showHandler(props.item)"
            ></ActionCell>
          </v-data-table>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { mapFields } from 'vuex-map-fields';
import ListMixin from '../../mixins/ListMixin';
import ActionCell from '../../components/ActionCell';
import CustomerFilterForm from '../../components/customer/Filter';
import DataFilter from '../../components/DataFilter';
import Toolbar from '../../components/Toolbar';
import AccessMixin from '../../mixins/AccessMixin';

export default {
  name: 'CustomerList',
  servicePrefix: 'Customer',
  mixins: [ListMixin,AccessMixin],
  components: {
    Toolbar,
    ActionCell,
    CustomerFilterForm,
    DataFilter
  },
  data() {
    return {
      headers: [
        { text: this.$t('global.id'), value: 'id' },
        { text: this.$t('qualitycheck.customer.name'), value: 'name' },
        { text: this.$t('ticket.tags'), value: 'tags' },
        {
          text: this.$t('global.actions'),
          value: 'action',
          sortable: false
        }
      ],
      selected: [],
footer: {
  'itemsPerPageText': "",
},
      options: {sortBy : ['name'], sortDesc : [false]}
    };
  },
  computed: {
    ...mapGetters('customer', {
      items: 'list'
    }),
    ...mapFields('customer', {
      deletedItem: 'deleted',
      error: 'error',
      isLoading: 'isLoading',
      resetList: 'resetList',
      totalItems: 'totalItems',
      view: 'view'
    })
  },
  methods: {
    ...mapActions('customer', {
      getPage: 'fetchAll',
      deleteItem: 'del'
    })
  }
};
</script>
